import { render, staticRenderFns } from "./recuperarSenha.vue?vue&type=template&id=27e6960a&scoped=true"
import script from "./recuperarSenha.vue?vue&type=script&lang=js"
export * from "./recuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./recuperarSenha.vue?vue&type=style&index=0&id=27e6960a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e6960a",
  null
  
)

export default component.exports